import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-campaign-type',
  templateUrl: './campaign-type.component.html',
  styleUrls: ['./campaign-type.component.scss']
})
export class CampaignTypeComponent implements OnInit {

  public data: any[] = [
    {
      list: [{
        'type': 'donation',
        'imageUrl': '/images/campaign-type/donation.png',
        'name': 'Donation',
        'description': 'This campaign type is suitable for most situations of donation.',
        'selected': false
      }, {
        'type': 'long-pledge',
        'imageUrl': '/images/campaign-type/long-pledge.png',
        'name': 'Long Pledge',
        'description': 'This campaign type is suitable for situations where donors pledge large amounts to be donated over a period of time (in months) in small installments.',
        'selected': false
      }]
    },
    {
      list: [{
        'type': 'ticketing',
        'imageUrl': '/images/campaign-type/ticketing.png',
        'name': 'Ticketing',
        'description': 'This type of campaign is suitable for tickets for events etc. where limited number of tickets available. It keeps count of inventory and mark unavailable when sold out.',
        'selected': false
      }, {
        'type': 'peer-to-peer-fundraising',
        'imageUrl': '/images/campaign-type/peer-to-peer.png',
        'name': 'Peer to Peer fundraising',
        'description': 'This type of campaign is suited for your most dedicated donors to collect donations from his or her friends.',
        'selected': false
      }]
    },
    {
      list: [{
        'type': 'auction',
        'imageUrl': '/images/campaign-type/auction.png',
        'name': 'Auction',
        'description': 'This campaign designed to manage donations for silent and live auctions. It supports online auction if you choose to enable it.',
        'selected': false
      }, {
        'type': 'last-hero',
        'imageUrl': '/images/campaign-type/last-hero.png',
        'name': 'Last Hero',
        'description': 'This campaign is used for the Last Hero fundraising game at events. This cannot be shared before or after the event',
        'selected': false
      }]
    },
    {
      list: [{
        'type': 'merchandise',
        'imageUrl': '/images/campaign-type/merchandise.png',
        'name': 'Merchandise',
        'description': 'This campaign is suitable for all kind of goods to be sold to donors. An example may be t-shirts at a fundraising walk-a-thon or sandwiches and milkshakes at a food carnival.',
        'selected': false
      }, {
        'type': 'party-signup',
        'imageUrl': '/images/campaign-type/party-signup.png',
        'name': 'Party Sign-ups',
        'description': 'This campaign may be used to create parties, experiences or events that donors can sign up for by purchasing one or more spots.',
        'selected': false
      }]
    },
    {
      list: [{
        'type': 'hindu-temple-puja',
        'imageUrl': '/images/campaign-type/hindu-temple-puja.png',
        'name': 'Hindu Temple Puja',
        'description': 'This campaign type is designed for Hindu temple puja offerings, help with donation and scheduling.',
        'selected': false
      }, {
        'type': 'in-kind',
        'imageUrl': '/images/campaign-type/donation.png',
        'name': 'In-Kind',
        'description': 'This campaign is used to track and send receipts for in kind donations. In-kind donations are items or services given by individuals or businesses usually to be auctioned off. ',
        'selected': false
      }]
    }
  ];

  public campaign = null;
  public confirmDisabled = true;

  constructor(
    private router: Router,
    public store: Store
  ) { }

  ngOnInit(): void {
  }

  onConfirm(campaign) {
    this.router.navigateByUrl(`campaign/${campaign.type}`);
  }

  onSelect(campaign) {
    if(this.campaign) {
      this.campaign.selected = false;
    }
    campaign.selected = true;
    this.campaign = campaign;

    this.confirmDisabled = false;
  }

}
